import React, { useContext } from "react"
import { Edit2, Trash2, X } from "react-feather"
import { CartContext } from "src/context/CartContext"
import Button from "src/components/core/atoms/button"
import {
  notes as s_notes, closeButton, footer
} from "./item-notes.module.css"

export const ItemNotes = ( { item, label = "Notes" } ) => {
  const { openNotesEditor, closeNotesEditor, addCartItemNotes, clearCartItemNote, notes } = useContext( CartContext )

  const handleClose = ( e ) => {
    if ( e.keyCode === 27 ) closeNotesEditor( item._id )
  }

  return (
    <div className={ s_notes }>
      {
        item.notes ? (
          <p>
            { item.notes }
            <span><Button variant="underlined" leftIcon={ <Edit2 /> } onClick={ () => openNotesEditor( item._id ) }>Edit</Button></span>
          </p>
        ) : (
          <span>+ <Button variant="underlined" onClick={ () => openNotesEditor( item._id ) } >{ label }</Button></span>
        )
      }
      {
        notes[ item._id ] && (
          <div >
            <textarea name="notes" id={ item._id } rows="3" autoFocus defaultValue={ item.notes }></textarea>
            <div
              className={ closeButton }
              role="button"
              aria-label="Close"
              tabIndex={ 0 }
              onKeyDown={ handleClose }
              onClick={ () => closeNotesEditor( item._id ) }>
              <X />
            </div>
            <div className={ footer }>
              <Button variant="solid" size="small" onClick={ addCartItemNotes }>
                { item.notes ? "Save" : "Add note" }
              </Button>
              <Button variant="text" size="small" hover="warn" onClick={ clearCartItemNote } leftIcon={ <Trash2 /> } />
            </div>
          </div>
        )
      }
    </div >
  )
}

export default ItemNotes